import { render, staticRenderFns } from "./admin-panel.vue?vue&type=template&id=d1ef84d0"
import script from "./admin-panel.vue?vue&type=script&lang=js"
export * from "./admin-panel.vue?vue&type=script&lang=js"
import style0 from "./admin-panel.vue?vue&type=style&index=0&id=d1ef84d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports